import { api } from '@/lib/api'
import type {
  Appointment,
  AppointmentCreatePayload,
  AppointmentUpdatePayload,
} from '@yui-receipt/shared'

export type { Appointment, AppointmentCreatePayload, AppointmentUpdatePayload }

export const APPOINTMENT_STATUS_LABELS: Record<Appointment['status'], string> = {
  booked: 'จองแล้ว',
  arrived: 'มาแล้ว',
  cancelled: 'ยกเลิก',
  no_show: 'ไม่มา',
}

export const APPOINTMENT_STATUS_COLORS: Record<Appointment['status'], string> = {
  booked: '#204687',
  arrived: '#16a34a',
  cancelled: '#94a3b8',
  no_show: '#dc2626',
}

export function listAppointments(fromIso: string, toIso: string) {
  const qs = new URLSearchParams({ from: fromIso, to: toIso })
  return api<{ appointments: Appointment[] }>(`/appointments?${qs}`)
}

export function createAppointment(payload: AppointmentCreatePayload) {
  return api<{ appointment: Appointment }>('/appointments', {
    method: 'POST',
    body: payload,
  })
}

export function updateAppointment(id: number, patch: AppointmentUpdatePayload) {
  return api<{ appointment: Appointment }>(`/appointments/${id}`, {
    method: 'PATCH',
    body: patch,
  })
}

export function listUsers() {
  return api<{ users: { id: number; username: string }[] }>('/users')
}
